export default __webpack_public_path__ + "static/media/Views.25480b0a.svg";